import { updateOrderDialogOpenState } from './orderDialogActions'
import {
  useTypedSunovationDispatch,
  useTypedSunovationSelector,
} from '../sunovationHooks'
import { selectOrderDialogOpenState } from './orderDialogSelectors'

export const useUpdateOrderDialogOpenState = () => {
  const dispatch = useTypedSunovationDispatch()
  return (openState: boolean) => {
    dispatch(updateOrderDialogOpenState(openState))
  }
}

export const useOrderDialogOpenState = () =>
  useTypedSunovationSelector(selectOrderDialogOpenState)
